import { ExternalPathString } from "expo-router";

export const instagramLink = (username: string) =>
  `https://instagram.com/${username}`;

export const tikTokLink = (username: string) =>
  `https://tiktok.com/@${username}`;

type AuthCallbackState = {
  brandId: string | null;
  timestamp: number;
  nonce: string;
  finalRedirectUrl: ExternalPathString;
  clientId: string;
  redirectUri: string;
};

export const encodeAuthState = (
  brandId: string | null,
  clientId: string,
  redirectUri: string,
) => {
  const state: AuthCallbackState = {
    brandId,
    timestamp: Date.now(),
    nonce: Math.random().toString(36).substring(2),
    finalRedirectUrl: document.location.pathname as ExternalPathString,
    clientId,
    redirectUri,
  };
  return btoa(JSON.stringify(state));
};

export const decodeAuthState = (state: string) => {
  return JSON.parse(atob(state)) as AuthCallbackState;
};

export const getInstagramAuthUrl = (
  brandId: string | null,
  redirectUri: string,
  clientId: string,
) => {
  const instagramUrlParams = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: "instagram_business_basic,instagram_business_manage_insights",
    response_type: "code",
    state: encodeAuthState(brandId, clientId, redirectUri),
  });
  return `https://www.instagram.com/oauth/authorize?${instagramUrlParams.toString()}`;
};

export const getTikTokAuthUrl = (
  brandId: string | null,
  redirectUri: string,
  clientId: string,
) => {
  const tiktokUrlParams = new URLSearchParams({
    client_key: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
    scope:
      "user.info.basic,user.info.username,user.info.stats,user.info.profile,user.account.type,user.insights,video.list,video.insights,comment.list,comment.list.manage",
    state: encodeAuthState(brandId, clientId, redirectUri),
    disable_auto_auth: "1",
  });
  return `https://www.tiktok.com/v2/auth/authorize?${tiktokUrlParams.toString()}`;
};
